import i18n from "i18next"
import LanguageDetector from 'i18next-browser-languagedetector'
import Logger from "logger/logger"
import {initReactI18next} from "react-i18next"
import {envQuery} from "store/system/environment/env.store"
import {isDev} from "utils/isDev"

const options = {
  order: ['querystring', 'navigator'],
  lookupQuerystring: 'lng'
}

/*****************************************************************************************
 *
 *  NEVER LOAD THIS FILE BEFORE useEnv() facade is loaded!
 *  It will fuck up the loading and setting of languages
 *
 ****************************************************************************************/

i18n.on('initialized', async () => {
  // We don't have any language from the envStore
  // So let's detect the language from browser strings and map it to our 3 letter language code
  if (!envQuery.getValue().language) {
    Logger('i18n.initialized.noEnvLanguage')
    const detectorLanguageMapper = {
      en: "eng",
      nl: "nld"
    }
    let lngIndex = Object.keys(detectorLanguageMapper).indexOf(i18n.language)
    if (lngIndex > -1) await i18n.changeLanguage(Object.values(detectorLanguageMapper)[lngIndex])
  } else {
    Logger('i18n.initialized.envLanguage', envQuery.getValue().language)
    await i18n.changeLanguage(envQuery.getValue().language)
  }
})

i18n.use(initReactI18next)  // passes i18n down to react-i18n
.use(LanguageDetector)
.init({
  detection: options,
  debug: isDev(),
  resources: {},
  interpolation: {
    escapeValue: false  // React already saves from XSS
  },
  fallbackLng: false,
  initImmediate: false,  // false -  https://www.i18n.com/overview/configuration-options#initimmediate
  react: {
    bindI18n: 'languageChanged',
    bindI18nStore: 'initialized',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    useSuspense: true,
  }
}).then()

interface ITranslationFileMapping {
  [key: string]: string[]
}

const fileLocations: ITranslationFileMapping = {
  auth: ["auth"],
  api: ["api"],
  components: [
    "avatar",
    "form",
    "moduleSettingsWrapper",
    "moduleWrapper",
    "operator",
    "permission",
    "systemNav",
    "widgetWrapper",
  ],
  modules: [
    "address",
    "bankAccount",
    "company",
    "dashboard",
    "emailAddress",
    "person",
  ],
  moduleSettings: [
    "layout"
  ],
  widgets: [
    "list",
    "entityLinker",
  ],
}
export const loadTranslation = async (lng: string) => {
  const keys = Object.keys(fileLocations) as string[]
  await Promise.all(keys.map(async key => {
    const filesNames = Object.values(fileLocations[key])
    await Promise.all(filesNames.map(async fileName => {
      const file = await require('./' + lng + '/' + key + '/' + fileName)
      i18n.addResourceBundle(lng, `${key}.${fileName}`, file.default, false, false)
    }))
  }))
}

export default i18n
